import { Component, ElementRef, HostBinding, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatIconRegistry } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable, of } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { BeforeSaveParam, BillComponent } from '../bill/bill.component';
import { IconSelectComponent } from '../components/icon-select/icon-select.component';
import { ModelElementCategory } from '../services/eleview/eleview-backface';
import { OwnerByEnum, ownerElement } from '../services/eleview/types/model';
import { Controller, ElementBackFace } from './service/back-face';
import { ElementDataRecordView, ElementService } from './service/element.service';
const RecordViewControllerName = 'recordview';
interface ElementPostTag {
	Roles: {
		Name: string;
		Checked: boolean;
		OldChecked: boolean;
	}[];
	Other: any;
}
interface ElementRecordViewPostTagOther {
	EleName: string;
	OwnerBy: OwnerByEnum;
	Owner: string;
	Data: ModelElementCategory[];
}
@Component({
	selector: 'common-element',
	templateUrl: './element.component.html',
	styleUrls: ['./element.component.scss'],
	providers: [ElementService, ElementBackFace]
})
export class ElementComponent implements OnInit {
	// ElementOwnerNormal æ­£å¸¸çå·¥ä½åç´ 
	readonly ElementOwnerNormal = 0;
	// ElementOwnerAutoCreate èªå¨åå»ºçå·¥ä½åç´ 
	readonly ElementOwnerAutoCreate = 1;

	@HostBinding('class.element') hostClass = true;
	@ViewChild('slider', { static: false })
	slider: ElementRef;
	@ViewChild('bill', { static: true })
	bill: BillComponent;
	filteredCategories: Observable<string[]>;
	filteredCategoriesEN: Observable<string[]>;
	filteredControllers: Observable<Controller[]>;
	constructor(
		iconRegistry: MatIconRegistry,
		sanitizer: DomSanitizer,
		public svr: ElementService,
		private dialog: MatDialog
	) {
		this.onBeforeSave = this.onBeforeSave.bind(this);
		const icons = [
			'all_chosen',
			'cancel_chosen',
			'return_chosen',
			'single_chosen',
			'double_down',
			'drag_indicator',
			'arrow_collapse',
			'arrow_expand',
			'sorting_arrows',
			'color_add',
			'file_copy'
		];
		icons.forEach(v => {
			iconRegistry.addSvgIcon(
				v,
				sanitizer.bypassSecurityTrustResourceUrl('assets/record-view/icon/' + v + '.svg')
			);
		});
	}

	ngOnInit() {
		this.bill.init.subscribe(() => {
			this.svr.bill = this.bill;
			const val = this.bill.formGroup.get('Params').value;
			if (val) {
				this.svr.Params = JSON.parse(val);
			} else {
				this.svr.Params = {};
			}
			this.svr.onInit(this.bill.element);
			this.svr.init.subscribe(() => {
				this.filteredCategories = this.bill.formGroup.get('Category').valueChanges.pipe(
					startWith(''),
					map((cate: string) => {
						return this.svr.Categories.filter(str => str.includes(cate));
					})
				);
				this.filteredCategoriesEN = this.bill.formGroup.get('CategoryEN').valueChanges.pipe(
					startWith(''),
					map((cate: string) => {
						return this.svr.CategoriesEN.filter(str => str.includes(cate));
					})
				);
				this.filteredControllers = this.bill.formGroup.get('Controller').valueChanges.pipe(
					startWith(''),
					map((ctr: string) => {
						return this.svr.Controllers.filter(c => c.Name.toLowerCase().includes(ctr.toLowerCase()));
					})
				);
			});
		});
	}
	baseActive() {
		this.svr.BaseActive = true;
		this.slider.nativeElement.style.top = '16px';
		this.slider.nativeElement.style.transition = 'all 0.5s';
	}
	tabActive(tab: string, event: MouseEvent) {
		this.svr.ActiveTab = tab;
		this.svr.BaseActive = false;
		this.slider.nativeElement.style.top = (<HTMLTableCellElement>event.target).offsetTop + 'px';
		this.slider.nativeElement.style.transition = 'all 0.5s';
	}
	onBeforeSave(self: BillComponent): Observable<BeforeSaveParam> {
		// éè¦æææ°ä¿®æ¹çè§è²ä¼ éå°åç«¯
		const tag = {
			Roles: this.svr.Roles.filter(v => v.Checked !== v.OldChecked) // åªéè¦ä¼ éåå¨çè§è²
		} as ElementPostTag;

		// åªéè¦èèææ°çæ¨¡åæ¯recordviewçæåµï¼ä¸éè¦èèä¹åæ¯recordviewï¼ç°å¨ä¸æ¯çæåµï¼è¿äºæåµ
		// å·²ç»å¨åç«¯è¿è¡äºå¤ç
		if (this.bill.formGroup.get('Controller').value === RecordViewControllerName) {
			const recviewSvr = this.svr.data.recordview as ElementDataRecordView;
			let eleName = this.bill.typeRecord.Name;
			// æ°å¢recordviewçèåé¡¹çè¯ï¼éè¦æelenameè®¾ç½®æææ°ç
			if (this.bill.isAdd()) {
				eleName = this.bill.formGroup.get('Name').value;
				const rec = recviewSvr.labelCategories || [];
				rec.forEach(v => (v.EleName = eleName));
			}
			if (this.bill.isAdd() || this.bill.isEdit()) {
				tag.Other = {
					EleName: eleName,
					OwnerBy: OwnerByEnum.ownerByEle,
					Owner: ownerElement,
					Data: recviewSvr.labelCategories
				} as ElementRecordViewPostTagOther;
			}
		}
		return of({ record: { Params: JSON.stringify(this.svr.Params) }, tag: tag } as BeforeSaveParam);
	}
	isBillController(): boolean {
		if (this.svr.Controllers && this.bill && this.bill.formGroup && this.bill.formGroup.get('Controller').value) {
			const found = this.svr.Controllers.find(v => v.Name === this.bill.formGroup.get('Controller').value);
			return found && found.Bill;
		}
		return false;
	}
	tabs(): string[] {
		if (this.bill && this.bill.formGroup && this.bill.formGroup.get('Controller').value) {
			if (this.isBillController()) {
				return this.svr.data.bill.Tabs;
			}
			if (this.svr.data[this.bill.formGroup.get('Controller').value]) {
				return this.svr.data[this.bill.formGroup.get('Controller').value].Tabs || [];
			}
		}

		return [];
	}
	selectIcon() {
		// æ¥çæèå é¤ç¶æä¸ï¼ä¸è½ä¿®æ¹å¾æ 
		if (this.bill.isBrowse() || this.bill.isDelete()) {
			return;
		}
		const v = {
			icon: this.bill.formGroup.get('Icon').value,
			color: this.bill.formGroup.get('Color').value
		};
		const dialogRef = this.dialog.open(IconSelectComponent, {
			width: '384px',
			height: '100%',
			data: v,
			position: {
				top: '0px',
				right: '0px'
			}
		});
		dialogRef.afterClosed().subscribe(result => {
			if (result) {
				this.bill.formGroup.get('Icon').setValue(result.icon);
				this.bill.formGroup.get('Color').setValue(result.color);
			}
		});
	}
}
